import { ApiError } from './api'

/**
 * Returns a short, user-facing message for an error.
 * Uses server message for ApiError (4xx) when safe; otherwise a generic actionable message.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message || 'La solicitud falló'
  }
  if (error instanceof Error) {
    const msg = error.message
    if (msg && msg.length < 200) return msg
    return 'Ha ocurrido un error. Intenta de nuevo.'
  }
  return 'Ha ocurrido un error. Intenta de nuevo.'
}
